import Axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  editBank: {
    isSuccess: false,
    isError: false,
    isFetching: false,
    message: "",
  },
};

export const editBankToDb = createAsyncThunk(
  "editBankToDb/editBankSlice",
  async (bank) => {
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    console.log("in editBankSlice", bank.id);
    const url = `${process.env.REACT_APP_NODE_URL}/api/set-bank-edit`;
    return await Axios.post(url, bank, config).then((response) => {
      return response.data;
    });
  }
);
const editBankSlice = createSlice({
  name: "editBank",
  initialState,
  reducers: {
    cleareditBank: (state) => {
      state.editBank.isError = false;
      state.editBank.isSuccess = false;
      state.editBank.isFetching = false;
      state.editBank.message = "";
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(editBankToDb.pending, (state) => {
      state.editBank.isFetching = true;
    });
    builder.addCase(editBankToDb.fulfilled, (state, action) => {
      state.editBank.isFetching = false;
      state.editBank.isSuccess = true;
      state.editBank.message = action.payload;
    });
    builder.addCase(editBankToDb.rejected, (state, action) => {
      state.editBank.isFetching = false;
      state.editBank.isError = true;
    });
  },
});
export const { cleareditBank } = editBankSlice.actions;
export default editBankSlice.reducer;
